import api from '@/api';
export const getCvsList = async ({ state, dispatch, commit }, params = {}) => {
  state = JSON.parse(JSON.stringify(state));
  let cvs = state.cvs;
  let res = {};
  if (!params.page) {
    cvs = [];
    params = {
      page_size: 20,
      page: 1
    };
  }
  res = await api.cvsV3.getCvsList(params);
  if (res.code !== 1000) {
    return false;
  }
  cvs = cvs.concat(res.data.cvs || []);
  commit('setCvs', cvs);
  commit('setCvsTotalCount', res.data.total_count)
  if (cvs.length < res.data.total_count) {
    params.page++;
    dispatch('getCvsList', params);
  }
  return res;
}

export const getOnlineCvData = async ({state, dispatch, commit}, cv_account_token) => {
  try {
    let res = await api.cvsV2.getOnlineCv(cv_account_token)
    if (res.code === 1000) {
      commit('setOnlineCvData', res.data)
      return res
    }
  } catch (e) {

  }
}
